export var SDK_VERSION = '6.13.3';
//# sourceMappingURL=version.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/@sentry/core/esm/version.js
// module id = 481
// module chunks = 140